import type { Step, Question, MultiQuestion } from '@de/types/types';
import type { FlowState } from '../providers/dynamicExperienceReducer';

/**
 * Process a single question for preselected options
 */
const processQuestion = (
  question: Question,
  flowState: FlowState,
  leadFieldOverride?: Step['leadFieldAssociated'],
) => {
  if (!question.options || question.options.length === 0) return;

  const preselectedOptions = question.options.filter(
    (option) => option.isPreSelected,
  );

  if (preselectedOptions.length > 0) {
    const isMultipleChoice = ['MULTIPLE_CHOICE', 'SELECT_ALL'].includes(
      question.questionType,
    );
    if (!question.id) return;
    flowState[question.id] = {
      option: isMultipleChoice ? preselectedOptions : preselectedOptions[0],
      leadFieldAssociated:
        leadFieldOverride ?? (question as Step).leadFieldAssociated,
    };
  }
};

/**
 * Initializes flow state with preselected options from step configuration
 * @param steps - Array of flow steps
 * @returns Flow state with preselected options
 */
export const initializePreselectedOptions = (steps: Step[]): FlowState => {
  const flowState: FlowState = {};

  steps.forEach((step) => {
    if (step.type === 'QUESTION') {
      processQuestion(step as Question, flowState);
    }

    if (step.type === 'MULTI_QUESTION' || step.type === 'DCS') {
      const multiStep = step as Step & Partial<MultiQuestion>;
      const childQuestions = multiStep.stepQuestions ?? [];
      childQuestions.forEach((child) => {
        processQuestion(child, flowState, child.leadFieldAssociated);
      });
    }
  });

  return flowState;
};
